var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-img"},[_c('img',{staticClass:"rounded w-full img-checkin",attrs:{"src":_vm.params.data.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }